import { getRegistry } from '../../getRegistry'


export const keyDownHooks = (props) => {
  const hooks = getRegistry('v2.keydown')
  const extensionHooks = getRegistry('extended.keydown');

  Object.entries(extensionHooks).forEach((val: any) => {
    const value = val[1]
    let hook = value.components[0]['component']
    hook(props)
  })
  Object.entries(hooks).forEach((val: any) => {
    const value = val[1]
    let hook = value.components[0]['component']
    hook(props)
  })
}
